import React, { Component } from 'react';

class IconYelp extends Component {
  render() {
    return (

      <div class="icon icon-yelp">

      <svg viewBox="0 0 48 63" xmlns="http://www.w3.org/2000/svg" xmlnsSerif="http://www.serif.com/"
fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g id="icon-yelp" fill="#dc0000">
        <path id="Shape" d="M18.832 44.389L10.071 54.93c-1.233 1.483-.644 3.723 1.163 4.426l8.566 3.33c1.847.719 3.856-.595 3.909-2.556l.369-13.807c.074-2.784-3.458-4.085-5.246-1.934z"
        />
        <path id="Shape1" serifId="Shape" d="M17.118 33.654L4.125 29.045c-1.828-.649-3.765.652-3.828 2.57l-.295 9.09c-.064 1.961 1.863 3.389 3.75 2.778l13.286-4.298c2.679-.866 2.732-4.59.08-5.531z"
        />
        <path id="Shape2" serifId="Shape" d="M32.017 35.61l13.309-3.625c1.872-.51 2.698-2.675 1.631-4.279l-5.056-7.599c-1.091-1.64-3.499-1.71-4.686-.137l-8.357 11.072c-1.685 2.232.442 5.308 3.159 4.568z"
        />
        <path id="Shape3" serifId="Shape" d="M22.347 3.511c.106-2.274-2.063-3.99-4.286-3.39L7.527 2.963c-2.273.613-3.238 3.271-1.879 5.172l12.089 20.693c.099.168.207.331.334.479 1.79 2.078 5.151 1.308 5.98-1.125.149-.437.191-.903.154-1.363L22.347 3.511z"
        />
        <path id="Shape4" serifId="Shape" d="M45.464 44.995L32.1 40.94c-2.694-.817-4.911 2.196-3.292 4.475l7.929 11.166c1.115 1.571 3.457 1.611 4.627.079l5.544-7.259c1.196-1.566.454-3.83-1.444-4.406z"
        />
    </g>
</svg>

      </div>

    );
  }
}

export default IconYelp;



// WEBPACK FOOTER //
// ./src/assets/components/icons/iconYelp.js